exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1C4jm9yjyxcjHTOcqh9NbJ {\n}\n", ""]);

// exports
exports.locals = {
	"getAge": "_1C4jm9yjyxcjHTOcqh9NbJ"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/GetAge/GetAge.css
// module id = 9582
// module chunks = 23